// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid a[data-v-4e1ff181]:before{content:\"\";padding-bottom:100%;display:inline-block;vertical-align:top}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
